export const setItem = (key, value) => {
  let parsedValue = value;

  if (value === Object(value)) {
    parsedValue = JSON.stringify(value);
  }

  return localStorage.setItem(key, parsedValue);
};

export const getItem = (key) => {
  const value = localStorage.getItem(key);

  if (isJsonString(value)) {
    return JSON.parse(value);
  }

  return value;
};

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch {
    return false;
  }
  return true;
}

export const removeItem = (key) => localStorage.removeItem(key);

export function updateStorageListItem(key, position, props) {
  const storage = getItem(key);
  const storageItem = storage && storage[position];

  setItem(key, {
    ...storage,
    [position]: {
      ...storageItem,
      ...props,
    },
  });
}

export const getLocalStorageItem = (key) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const setLocalStorageItem = async (key, value) => {
  return localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorageItem = (key) => {
  return localStorage.removeItem(key);
};
